const __DEV__ = false;

import _defineProperty from '@babel/runtime/helpers/defineProperty';
import breakpoints from './breakpoints.yaml.js';
import colors from './colors.yaml.js';
import constraints from './constraints.yaml.js';
import shadows from './shadows.yaml.js';
import shape from './shape.yaml.js';
import spacing from './spacing.yaml.js';
import typography from './typography.yaml.js';
import zIndex from './zIndex.yaml.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var internals = _objectSpread(_objectSpread(_objectSpread({}, breakpoints), typography), {}, {
  colors: _objectSpread({}, colors.colors),
  constraints: _objectSpread({}, constraints.constraints.values),
  shadows: _objectSpread({}, shadows.shadows.values),
  shape: {
    borderRadius: shape.borderRadius.values
  },
  spacing: _objectSpread({}, spacing.spacing.values),
  zIndex: _objectSpread({}, zIndex.zIndex.values)
});
var internals$1 = internals;

export { internals$1 as default };
//# sourceMappingURL=index.js.map
